import {FilterMultiSelect, FilterMultiSelectProps} from '@widgets/common-filters'
import {StatusLabel} from '@widgets/common-shift-event'
import {useTranslation} from 'react-i18next'

import {FILTER_VALUE_SEPARATOR, FEATURE_NAMESPACE} from '../../consts'
import {TaskStatus} from '../../types'

export const TaskStatusFilter = <TName extends string>({
  ...props
}: Omit<FilterMultiSelectProps<TaskStatus, TName>, 'options'>) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const options = Object.values(TaskStatus).map((status) => ({
    value: status,
    label: t(`task.status.${status}`)
  }))

  return (
    <FilterMultiSelect
      {...props}
      options={options}
      getOptionLabel={({value, label}) => <StatusLabel status={value} label={label} />}
      renderValue={(value) =>
        value.map((status) => t(`task.status.${status}`)).join(FILTER_VALUE_SEPARATOR)
      }
    />
  )
}
